import React from 'react';
import { create } from 'react-modal-promise';
import StyledWMDialog from '../../Dialogs/StyledWMDialog/StyledWMDialog';
import classes from './CSVExportDialog.module.scss';
import { useTranslation } from 'react-i18next';

const keyPrefix = 'components.notificationsList.notificationsDataExport.noDataExistsDialog';

export const NoDataExistsDialog = ({ isOpen, close }: $TSFixMe) => {
    const { t } = useTranslation('', { keyPrefix });

    const onDiscard = () => {
        close();
    };

    const buttons = [
        {
            children: t('close'),
            className: classes.noDataExistsDialogCloseBtn,
            onClick: () => onDiscard(),
            'data-testid': 'csv-export-no-data-exists-dialog-close-button'
        }
    ];

    return (
        <StyledWMDialog title={t('noDataToExport')} open={isOpen} onClose={close} buttons={buttons} data-testid={'csv-export-no-data-exists-dialog'}>
            {t('noDataForSelectedDateRange')}
        </StyledWMDialog>
    );
};

NoDataExistsDialog.openModal = create(NoDataExistsDialog);
export default NoDataExistsDialog;
